import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import * as React from "react";

import { RobotoButton } from "@/shared/components/RobotoButton";
import { docsUrl } from "@/shared/environment";
import { MenuBookRoundedIcon } from "@/shared/foundation/icons/mui";

import { ModeToggleSearchBarMode } from "../types";

interface SearchModeToggleProps {
  mode: ModeToggleSearchBarMode;
  onModeChanged: (arg: ModeToggleSearchBarMode) => void;
}

export const SearchModeToggle: React.FC<SearchModeToggleProps> = ({
  mode,
  onModeChanged,
}) => {
  const handleChangeMode = (
    _event: React.MouseEvent<HTMLElement>,
    newMode: string,
  ) => {
    if (newMode !== null) {
      onModeChanged(newMode as ModeToggleSearchBarMode);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <ToggleButtonGroup
        color={"primary"}
        value={mode}
        exclusive
        onChange={handleChangeMode}
        sx={{
          height: "32px",
          display: {
            xs: "none",
            sm: "inline-flex",
          },
        }}
      >
        <ToggleButton
          data-cy={"basicQueryButton"}
          value={"basic"}
          sx={{
            textTransform: "none",
          }}
        >
          Basic
        </ToggleButton>
        <ToggleButton
          data-cy={"basicRoboqlButton"}
          value={"roboql"}
          sx={{
            textTransform: "none",
          }}
        >
          RoboQL
        </ToggleButton>
      </ToggleButtonGroup>
      {mode === "roboql" && (
        <Box
          sx={{
            display: {
              xs: "none",
              sm: "inline-flex",
            },
          }}
        >
          <RobotoButton
            variant="text"
            sx={{ mt: "5px" }}
            eventName={"OpenRoboQLDocsClicked"}
            disableFocusRipple
            startIcon={<MenuBookRoundedIcon />}
            href={docsUrl("/roboql/overview")}
          >
            <Typography variant="subtitle2">RoboQL Docs</Typography>
          </RobotoButton>
        </Box>
      )}
    </Box>
  );
};
